import styled from '@emotion/styled';
import { Col } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import * as S from 'src/modules/programs/stepComponents/styles';
import { QuestionsRow, SurveyHeader } from 'src/modules/programs/surveys/components/styles';
import { SurveyQuestionSwitch } from 'src/modules/programs/surveys/components/SurveyQuestionSwitch';
import { GenericSurveyQuestion } from 'src/modules/programs/surveys/models/surveys';
import { GenericProgramSurvey } from 'src/modules/programs/surveys/models/surveysGeneric';
import { getProgramSurveyQuestionByRenderId } from 'src/modules/programs/surveys/selectors/surveysSelectors';
import { mediaQueries } from 'src/shared/styles/variables';

interface ProsAndConsQuestionWrapperProps {
    right?: boolean;
}

const ProsAndConsQuestionWrapper = styled(Col)<ProsAndConsQuestionWrapperProps>(({ right }) => ({
    paddingLeft: right ? '0.75rem' : 0,
    paddingRight: right ? 0 : '0.75rem',
    [mediaQueries.md]: {
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: '1rem',
    },
}));

export interface StateProps {
    makingChangeProsQuestion?: GenericSurveyQuestion;
    makingChangeConsQuestion?: GenericSurveyQuestion;
    stayingSameProsQuestion?: GenericSurveyQuestion;
    stayingSameConsQuestion?: GenericSurveyQuestion;
}

export interface Props extends StateProps {
    programId: ProgramEnum;
    surveyId: GenericProgramSurvey;
    makingChangeHeading: string;
    stayingSameHeading: string;
}

export const ProsAndConsTabContainer: React.SFC<Props> = ({
    programId,
    surveyId,
    makingChangeHeading,
    stayingSameHeading,
    makingChangeProsQuestion,
    makingChangeConsQuestion,
    stayingSameProsQuestion,
    stayingSameConsQuestion,
}) => {
    const commonQuestionProps = { programId, surveyId, noShadow: true, noPadding: true };

    return (
        <S.TabPaneContent noPadding>
            <S.StepBoxWrapper boxShadow noTopMargin>
                <SurveyHeader>{makingChangeHeading}</SurveyHeader>
                <QuestionsRow type="flex">
                    <ProsAndConsQuestionWrapper md={12}>
                        <SurveyQuestionSwitch
                            {...commonQuestionProps}
                            question={makingChangeProsQuestion}
                        />
                    </ProsAndConsQuestionWrapper>
                    <ProsAndConsQuestionWrapper md={12} right>
                        <SurveyQuestionSwitch
                            {...commonQuestionProps}
                            question={makingChangeConsQuestion}
                        />
                    </ProsAndConsQuestionWrapper>
                </QuestionsRow>
            </S.StepBoxWrapper>
            <S.StepBoxWrapper boxShadow>
                <SurveyHeader>{stayingSameHeading}</SurveyHeader>
                <QuestionsRow type="flex">
                    <ProsAndConsQuestionWrapper md={12}>
                        <SurveyQuestionSwitch
                            {...commonQuestionProps}
                            question={stayingSameProsQuestion}
                        />
                    </ProsAndConsQuestionWrapper>
                    <ProsAndConsQuestionWrapper md={12} right>
                        <SurveyQuestionSwitch
                            {...commonQuestionProps}
                            question={stayingSameConsQuestion}
                        />
                    </ProsAndConsQuestionWrapper>
                </QuestionsRow>
            </S.StepBoxWrapper>
        </S.TabPaneContent>
    );
};

const mapStateToProps = (state: AppState, { programId, surveyId }: Props): StateProps => {
    const surveyRelatedArgs = [state, programId, surveyId] as any;

    return {
        makingChangeProsQuestion: getProgramSurveyQuestionByRenderId.apply(null, [
            ...surveyRelatedArgs,
            'makingChangePros',
        ]),
        makingChangeConsQuestion: getProgramSurveyQuestionByRenderId.apply(null, [
            ...surveyRelatedArgs,
            'makingChangeCons',
        ]),
        stayingSameProsQuestion: getProgramSurveyQuestionByRenderId.apply(null, [
            ...surveyRelatedArgs,
            'stayingSamePros',
        ]),
        stayingSameConsQuestion: getProgramSurveyQuestionByRenderId.apply(null, [
            ...surveyRelatedArgs,
            'stayingSameCons',
        ]),
    };
};

export const ProsAndConsTab = connect<StateProps>(mapStateToProps)(ProsAndConsTabContainer);
